// @flow
import React, { Component } from 'react';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import PropTypes from 'prop-types';

import style from './MissingForMaxValue.scss';
import icons from '../../assets/styles/icons.scss';
import buttonStyle from '../../assets/styles/button.scss';
import CheckoutStep from '../../modules/new-order/CheckoutStep/components/CheckoutStep';

type Props = {
  amount: number;
  isNarrow?: boolean;
};

const messages = defineMessages({
  partOne: {
    id: 'missingForMaxValue.message.partOne',
  },
  partTwo: {
    id: 'missingForMaxValue.message.partTwo',
  },
  information: {
    id: 'missingForMaxValue.information',
  },
});

const MAX_VALUE = 40;

export default class MissingForMaxValue extends Component<Props> {

  render() {
    const { amount, isNarrow = false } = this.props;
    const percent = (amount / MAX_VALUE) * 100;

    return (
      <section className={style.missingForMaxValue}>
        <section className={style.top}>
          <div className={style.circle}>
            <i className={icons.iconBoxMedium}/>
          </div>
          <p>{`${this.context.intl.formatMessage(messages.partOne)} `}
            <span>$ {((MAX_VALUE - amount).toFixed(2))}</span>
            {` ${this.context.intl.formatMessage(messages.partTwo)} `}{/*isNarrow && <br/>*/}
            {/*<a href="#" target="_blank">{this.context.intl.formatMessage(messages.information)}</a>*/}</p>
        </section>
        <section className={style.bottom}>
          <p>$ 0</p>
          <section className={style.bar}>
            <div className={style.amountBar} style={{ width: `${percent}%` }}>
              <div className={style.point}/>
            </div>
          </section>
          <p>$ {MAX_VALUE}</p>
        </section>
      </section>)
  }
}

MissingForMaxValue.propTypes = {
  amount: PropTypes.number.isRequired,
  isNarrow: PropTypes.bool,
};

MissingForMaxValue.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/elements/MissingForMaxValue/MissingForMaxValue.jsx